// extracted by mini-css-extract-plugin
export default {"articles":"Articles_articles__h7q1y","articles__errorMessage":"Articles_articles__errorMessage__g3S77"};